export class TextureAtlasUtils {
    //-------------------------------------------------------------------------
    /**
     * Vraci region daneho framu v atlasu (U, V, W, H)
     * @param atlas 
     * @param frame 
     * @param out
     * @returns Pokud frame v atlasu neexistuje, tak vraci undefined
     */
    //-------------------------------------------------------------------------
    static getAtlasFrameRegion(atlas: pc.TextureAtlas, frameKey: string, out?: pc.Vec4): pc.Vec4 {
        // Ziskat snimek
        let frame = atlas.frames[frameKey] as pc.TextureAtlasFrame;

        if (!frame)
            return undefined;

        // Prepocitat
        return TextureAtlasUtils.getTexFrameRegion(atlas.texture, frame.rect, out);
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci region daneho frame v texture (U, V, W, H)
     * @param texture 
     * @param frameRect 
     * @param out 
     */
    //-------------------------------------------------------------------------
    static getTexFrameRegion(texture: pc.Texture, frameX: number | pc.Vec4, out?: pc.Vec4, frameY?: number, frameW?: number, frameH?: number): pc.Vec4 {
        let texW = texture.width;
        let texH = texture.height;

        if (!out)
            out = new pc.Vec4();

        if (frameX instanceof pc.Vec4) {
            frameY = frameX.y;
            frameW = frameX.z;
            frameH = frameX.w;
            frameX = frameX.x;
        }

        out.x = frameX / texW;
        out.y = frameY / texH;
        out.z = frameW / texW;
        out.w = frameH / texH;

        return out;
    }
}